import script from "./VehicleInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&setup=true&lang=js"

import "./VehicleInfo.vue?vue&type=style&index=0&id=4268ffb2&lang=css"

const __exports__ = script;

export default __exports__